<template>
    <div class="container">
        <div class="row" v-if="!this.loading">
            <div class="col-md-6">
                <h2>Delete</h2> 
                <h5>Retailer Visit</h5>
            </div>
        </div> 
        <div class="row mt-4" v-if="!this.loading">
            <div class="col col-md-12 border-top border-bottom py-4 ">
                <h3>Are you sure you want to delete visit for '{{ retailer_name }}' on date {{ visit_date }} ?</h3> 
                <div class="form-group row">
                    <div class="col-sm-12 mt-2">
                        <button @click.prevent="destroy" class="btn btn-danger">YES</button> <router-link :to="{name:'retailers.details', params: {id: retailerId}}" class="btn btn-light">NO</router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="row d-flex justify-content-center" v-else>
                <div class="spinner-border text-primary" style="margin-top:4rem; margin-bottom:4rem; width: 4rem; height: 4rem;" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
        </div>
    </div>
</template>

<script>
import RetailerVisitsService from '../../../services/RetailerVisitsService';

export default {
    props: {
        id: {
            default: null,
        },
        retailerId: {
            default: null,
        }
    },

    data(){
        return {
            loading: true,
            visit_date: '',
            retailer_name: ''
        }
    },

    mounted(){
        this.load();
    },

    methods: {
        destroy: function () {
            RetailerVisitsService.destroy(this.id)
                .then(res => this.success(res));
        },
        success: function (res) {
            window.flash(res.data.message);
            this.$router.push({name:'retailers.details', params:{id: this.retailerId}});
        },
        load: function () {
            this.loading = true;
            RetailerVisitsService.get(this.id)
                .then( res => this.init(res));
        },
        init: function (res) {
            this.loading = false;
            this.visit_date = res.data.data.visit_date;
            this.retailer_name = res.data.data.retailer.retailer_name;
        },
    },
}
</script>